import { render, staticRenderFns } from "./gstr_sub_report.vue?vue&type=template&id=657ec43f&"
import script from "./gstr_sub_report.vue?vue&type=script&lang=js&"
export * from "./gstr_sub_report.vue?vue&type=script&lang=js&"
import style0 from "./gstr_sub_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
